var exports = {
  "Qs": "x61f99309--f603b4--content",
  "cG": "x61f99309--f603b4--img-container",
  "_8": "x61f99309--f603b4--img",
  "Qq": "x61f99309--f603b4--text",
  "VA": "x61f99309--f603b4--subtitle",
  "QY": "x61f99309--f603b4--dismiss-button",
};

module.exports = exports;
